import React from 'react';
import * as Styled from '../SearchAutocompleteResults.styles';

interface ImagesProps {
  images: string[];
}

export const Images: React.FC<ImagesProps> = ({ images = [] }) => {
  const slicedImages = images.slice(0, 4);

  return (
    <Styled.BoardImages imageNumber={slicedImages?.length}>
      {slicedImages.map((image, index) => (
        <Styled.BoardImageGrid key={index} image={image} />
      ))}
      {slicedImages?.length === 0 && <Styled.BoardImagePlaceholder />}
    </Styled.BoardImages>
  );
};
